import {useSigninCheck} from 'reactfire';
import {SigninStatus} from '../types';

/* v8 ignore next -- @preserve */
export function useSigninStatus(): SigninStatus {
  const {error, status, data: signInCheckResult} = useSigninCheck();
  return {isLoading: status === 'loading', isSignedIn: signInCheckResult?.signedIn === true, signinError: error};
}
